<template>
  <div class="favorites-page">
    <div class="page-header">
      <h1>
        <svg class="title-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        我的收藏
      </h1>
      <p>收藏你喜欢的漫画，方便下次阅读</p>
    </div>

    <div v-if="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else-if="favorites.length === 0" class="empty-state">
      <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
      <p>还没有收藏漫画</p>
      <button @click="goHome" class="btn-primary">去首页看看</button>
    </div>

    <div v-else class="favorites-grid">
      <div v-for="item in favorites" :key="item.comic_id" class="favorite-card" @click="goToComic(item.comic_id)">
        <img :src="item.cover || '/logo.png'" class="favorite-cover" alt="封面" />
        <div class="favorite-info">
          <h3 class="favorite-title">{{ item.title }}</h3>
          <p class="favorite-author">{{ item.author || '未知作者' }}</p>
          <span class="favorite-status">{{ item.status_text || '连载中' }}</span>
        </div>
        <button @click.stop="removeFavorite(item.comic_id)" class="remove-btn" title="取消收藏">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFavorites, toggleFavorite } from '../api/index';

export default {
  name: 'FavoritesPage',
  data() {
    return {
      loading: true,
      favorites: []
    };
  },
  mounted() {
    this.loadFavorites();
  },
  methods: {
    async loadFavorites() {
      this.loading = true;
      try {
        const res = await getFavorites({ page: 1, limit: 50 });
        if (res.data && res.data.code === 1) {
          this.favorites = res.data.data.list || [];
        }
      } catch (e) {
        console.error('加载收藏失败:', e);
      } finally {
        this.loading = false;
      }
    },

    goToComic(comicId) {
      this.$router.push(`/comic/${comicId}`);
    },

    async removeFavorite(comicId) {
      if (!confirm('确定要取消收藏吗？')) return;
      try {
        const res = await toggleFavorite(comicId);
        if (res.data && res.data.code === 1) {
          this.favorites = this.favorites.filter(item => item.comic_id !== comicId);
        }
      } catch (e) {
        console.error('取消收藏失败:', e);
        alert('操作失败');
      }
    },

    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.favorites-page {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text);
}

.page-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 22px 24px;
  background: linear-gradient(135deg, var(--brand-deep) 0%, var(--brand) 100%);
  color: #fff;
  border-radius: 8px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-header p {
  margin: 0;
  opacity: 0.9;
  font-size: 13px;
}

.title-svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 50px 20px;
  color: var(--text-dim);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--surface-3);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.favorites-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 18px;
}

.favorite-card {
  position: relative;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.favorite-card:hover {
  border-color: var(--brand);
  transform: translateY(-3px);
}

.favorite-cover {
  width: 100%;
  aspect-ratio: 3/4;
  object-fit: cover;
  display: block;
}

.favorite-info {
  padding: 10px;
}

.favorite-title {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: var(--text);
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.favorite-author {
  margin: 0 0 6px 0;
  font-size: 12px;
  color: var(--text-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.favorite-status {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 99px;
  background: var(--brand-soft);
  color: var(--brand);
}

.remove-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.favorite-card:hover .remove-btn {
  opacity: 1;
}

.remove-btn:hover {
  background: var(--danger);
}

.btn-primary {
  background: var(--brand);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: var(--brand-hover);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .favorites-page {
    margin: 10px;
    padding: 15px;
  }

  .favorites-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }
}
</style>
